import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { PHILOSOPHY, PAGE_BANNERS } from "../data/content";

export default function Philosophy() {
  const n = PHILOSOPHY.naturopathy;
  const c = PHILOSOPHY.chinese;
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.medicine} alt="The Medicine" fallbackKey="medicine" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>{PHILOSOPHY.title}</h1>
          <p className="nn-italic-tagline -mt-2 mb-6">{PHILOSOPHY.subtitle}</p>
          <p>{PHILOSOPHY.intro}</p>

          <h2 className="!text-2xl tracking-wider uppercase border-b border-[#d6dcb6] pb-2">Naturopathy</h2>
          <h3>History</h3>
          <p>{n.history}</p>
          <h3>Approach</h3>
          <p>{n.approach}</p>
          <h3>Education &amp; Training</h3>
          <p>{n.education}</p>
          <h3>Principles of Naturopathic Care</h3>
          <ul>
            {n.principles.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
          <h3>Learn More about Naturopathic Medicine</h3>
          <p>{n.learnMore}</p>

          <h2 className="!text-2xl tracking-wider uppercase border-b border-[#d6dcb6] pb-2">Chinese Medicine</h2>
          <h3>History</h3>
          <p>{c.history}</p>
          <h3>Philosophy</h3>
          <p>{c.philosophy}</p>
          <h3>How Chinese Medicine Works</h3>
          <p>{c.how}</p>
        </article>
      </div>
    </div>
  );
}
